import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from 'antd';

function Header() {
  const history = useHistory();

  function handleBack() {
    history.goBack();
  }

  return (
    <header className='flex items-center justify-between'>
      <h1 className='mb-0! text-2xl font-semibold'>Nova oferta</h1>
      <Button id='back-button' onClick={handleBack}>
        Voltar
      </Button>
    </header>
  );
}

export { Header };
